module.exports = __webpack_public_path__ + "static/media/popup-chat-plus.2c2e98aa.svg";